import _ from "lodash";
import React, { useState } from "react";
import classes from "./LogoutModal.scss";
import { Button, Checkbox, Modal } from "@toddle-edu/ds-web";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

const LogoutModal = props => {
  const { t, logoutModalOpen, setLogoutModalOpen, handleLogout } = props;

  const [logoutAllDevices, setLogoutAllDevices] = useState(false);

  const toggleLogoutAllDevices = e => setLogoutAllDevices(e.target.checked);

  const toggleLogoutModalOpen = () => {
    setLogoutModalOpen(!logoutModalOpen);
    setLogoutAllDevices(false);
  };

  const handleLogoutClick = async () => {
    handleLogout({ logoutAllDevices });
    setLogoutAllDevices(false);
  };

  return (
    <Modal
      isOpen={logoutModalOpen}
      onClose={toggleLogoutModalOpen}
      width="496px"
      height="430px"
    >
      <Modal.Header title={t("common:logout_of_toddle")} isClosable={true} />
      <Modal.Body>
        <div className={classes.logoutModalBody}>
          <div className={classes.logoutModalBodyText}>
            <span>{t("common:logout_of_toddle_confirmation")}</span>
            <span>{t("common:logout_of_all_devices_confirmation")}</span>
          </div>

          <div className={classes.logoutAllDevicesCheckbox}>
            <Checkbox
              isChecked={logoutAllDevices}
              onChange={toggleLogoutAllDevices}
            >
              {t("common:logout_of_all_devices_checkbox")}
            </Checkbox>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className={classes.logoutModalFooter}>
          <Button variant="outlined-subtle" onClick={toggleLogoutModalOpen}>
            {t("common:cancel")}
          </Button>

          <Button variant="destructive" onClick={handleLogoutClick}>
            {t("common:logout")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo(state);
  const userType = _.get(userInfo, "user_type", "");
  return {
    userType,
  };
};

export default compose(connect(mapStateToProps, null))(LogoutModal);
